import { AuthConfig, OAuthModuleConfig } from "angular-oauth2-oidc";
import { environment } from "src/environments/environment";

export const authConfig: AuthConfig = {
  issuer: environment.authenticationUrl,
  customQueryParams: {
    organizationUUID: environment.organizationUUID,
    organization: environment.organizationUUID,
    // userType: 'ApplicationUser@cataleanUser', //Tipo_UTENTE@Tipo_INTEGRAZIONE
		idmUserType: 'cataleanUser', //
  },
  requireHttps: environment.production,
  clientId: 'multitrax-integration', // The "Auth Code + PKCE" client
  responseType: 'code',
  redirectUri: window.location.origin,
  logoutUrl: window.location.origin,
  scope: 'openid profile email organization', // Ask offline_access to support refresh token refreshes
  timeoutFactor: 0.75, // decrease this value for faster testing
  sessionChecksEnabled: false,
  showDebugInformation: !environment.production,
  clearHashAfterLogin: false, // https://github.com/manfredsteyer/angular-oauth2-oidc/issues/457#issuecomment-431807040,
  nonceStateSeparator: 'semicolon', // Real semicolon gets mangled by IdentityServer's URI encoding
};

export const authModuleConfig: OAuthModuleConfig = {
  resourceServer: {
    allowedUrls: [],
    sendAccessToken: true,
  },
};
